const initialState = { 
  loading: false,
  success: null,
  error: null
}

function editOrderTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case 'EDIT_ORDER_TRANSACTION_DROPSHIPPING_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'EDIT_ORDER_TRANSACTION_DROPSHIPPING_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'EDIT_ORDER_TRANSACTION_DROPSHIPPING_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default editOrderTransactionReducer
